{
  "clinicalNotes": "診療ノート",
  "noteType": "ノート種別",
  "author": "記載者",
  "dateTime": "日時",
  "content": "内容",
  "addNote": "ノート追加",
  "editNote": "ノート編集",
  "signNote": "ノート署名",
  "signed": "署名済み",
  "unsigned": "未署名",
  "types": {
    "progressNote": "経過記録",
    "admissionNote": "入院時記録",
    "dischargeNote": "退院時記録",
    "consultNote": "コンサルテーション記録",
    "procedureNote": "処置記録"
  },
  "editor": {
    "newNote": "新規ノート",
    "titlePlaceholder": "ノートのタイトル…",
    "create": "作成",
    "cancel": "キャンセル",
    "cosignFilterLabel": "自分の連署が必要なノートのみ表示します",
    "emptyNoCosign": "連署が必要なノートはありません",
    "emptyNoNotes": "ノートはまだありません",
    "emptySelection": "ノートを選択するか、新規作成してください",
    "emptySelectionHint": "左側のリストから選ぶか、「+ 新規ノート」を押して開始してください。",
    "unknownAuthor": "不明",
    "needsCosignBadge": "連署必要",
    "amendmentBanner": "ノート #{{parentId}} の訂正 — 理由:{{reason}}",
    "signedBanner": "{{name}} が {{when}} に署名しました — このノートは読み取り専用です。",
    "signedByFallback": "医師",
    "saving": "保存中…",
    "autoSaved": "自動保存しました",
    "actions": {
      "saveDraft": "下書きを保存",
      "signNote": "ノートに署名",
      "amend": "訂正",
      "cosign": "連署",
      "printLabel": "ノートを印刷"
    },
    "copyForward": "前回の記録を引き継ぐ",
    "copyForwardHint": "{{date}} の署名済み記録を引き継ぎます — 各項目を確認・更新してください",
    "copiedForwardBadge": "引き継ぎ"
  },
  "dialog": {
    "sign": {
      "title": "ノートに署名",
      "body": "このノートに署名してよろしいですか?この操作は取り消せません。署名後、ノートは読み取り専用になります。",
      "cancel": "キャンセル",
      "confirm": "署名を確定"
    },
    "amend": {
      "title": "ノートを訂正",
      "body": "訂正の理由を入力してください。ノートが更新され、訂正済みとして表示されます。",
      "reasonPlaceholder": "訂正理由…",
      "cancel": "キャンセル",
      "confirm": "訂正を確定"
    },
    "cosign": {
      "title": "ノートを連署",
      "body": "このノートを連署してよろしいですか?内容を確認し同意したことを意味します。",
      "cancel": "キャンセル",
      "confirm": "連署を確定"
    }
  },
  "toast": {
    "created": "ノートを作成しました",
    "createFailed": "ノートの作成に失敗しました",
    "titleRequired": "ノートのタイトルを入力してください",
    "draftSaved": "下書きを保存しました",
    "signed": "ノートに署名しました",
    "signFailed": "ノートの署名に失敗しました",
    "amended": "ノートを訂正しました",
    "amendFailed": "ノートの訂正に失敗しました",
    "amendReasonRequired": "訂正理由を入力してください",
    "cosigned": "ノートを連署しました",
    "cosignFailed": "ノートの連署に失敗しました"
  },
  "status": {
    "draft": "下書き",
    "unsigned": "未署名",
    "signed": "署名済み",
    "amended": "訂正済み",
    "cosigned": "連署済み",
    "cosignNeeded": "連署必要",
    "pendingSignature": "署名待ち",
    "addendum": "追記",
    "cosignPending": "連署待ち"
  },
  "worklist": {
    "title": "未署名ノート ワークリスト",
    "backToDashboard": "ダッシュボード",
    "filtersHeading": "フィルター",
    "filterAllNoteTypes": "すべてのノート種別",
    "filterAllStatuses": "すべてのステータス",
    "filterAuthorPlaceholder": "記載者で絞り込み…",
    "dateFromAria": "ノート開始日",
    "dateToAria": "ノート終了日",
    "columns": {
      "patient": "患者",
      "mrn": "MRN",
      "noteType": "ノート種別",
      "noteTitle": "タイトル",
      "author": "記載者",
      "created": "作成日時",
      "status": "ステータス",
      "actions": "操作"
    },
    "actions": {
      "signSelected": "選択分に署名({{count}})",
      "signing": "署名中…",
      "open": "開く",
      "refresh": "更新"
    },
    "loading": "ノートを読み込み中…",
    "empty": "未署名ノートが見つかりません",
    "loadError": "未署名の記録の読み込みに失敗しました",
    "retry": "再試行",
    "toast": {
      "noneSelected": "ノートが選択されていません",
      "signed_one": "{{count}} 件のノートに署名しました",
      "signed_other": "{{count}} 件のノートに署名しました",
      "signFailed": "一部のノートの署名に失敗しました",
      "partiallySigned_one": "{{count}} 件のノートに署名しました（{{failed}} 件失敗）",
      "partiallySigned_other": "{{count}} 件のノートに署名しました（{{failed}} 件失敗）"
    }
  },
  "type": {
    "progress": "経過記録",
    "historyPhysical": "H&P",
    "admission": "入院時記録",
    "discharge": "退院サマリー",
    "consult": "コンサルテーション",
    "procedure": "処置記録",
    "operative": "手術記録",
    "nursing": "看護記録"
  },
  "template": {
    "list": {
      "title": "ノートテンプレート",
      "backToDashboard": "ダッシュボード",
      "newButton": "新規テンプレート",
      "columns": {
        "name": "名称",
        "noteType": "ノート種別",
        "specialty": "診療科",
        "sections": "セクション",
        "status": "ステータス",
        "actions": "操作"
      },
      "active": "有効",
      "inactive": "無効",
      "loading": "テンプレートを読み込み中…",
      "empty": "テンプレートがありません。作成してください。",
      "previewTitle": "テンプレートプレビュー:{{name}}",
      "emptySection": "(空)",
      "tooltips": {
        "preview": "プレビュー",
        "edit": "編集",
        "activate": "有効化",
        "deactivate": "無効化"
      },
      "toast": {
        "statusUpdated": "テンプレートの状態を更新しました"
      }
    },
    "form": {
      "editTitle": "テンプレート編集",
      "createTitle": "テンプレート作成",
      "fields": {
        "name": "テンプレート名",
        "noteType": "ノート種別",
        "specialty": "診療科",
        "sections": "セクション"
      },
      "required": "*",
      "namePlaceholder": "例:標準経過記録",
      "selectNoteType": "種別を選択…",
      "selectSpecialty": "診療科を選択…",
      "addSection": "セクションを追加",
      "sectionNamePlaceholder": "セクション名(例:主訴)",
      "sectionDefaultPlaceholder": "このセクションの既定内容…",
      "cancel": "キャンセル",
      "create": "テンプレートを作成",
      "update": "テンプレートを更新",
      "toast": {
        "created": "テンプレートを作成しました",
        "updated": "テンプレートを更新しました",
        "saveFailed": "テンプレートの保存に失敗しました",
        "nameAndTypeRequired": "名称とノート種別は必須です",
        "atLeastOneSection": "セクションは少なくとも1つ必要です"
      }
    },
    "specialty": {
      "general": "総合診療科",
      "internalMedicine": "内科",
      "surgery": "外科",
      "pediatrics": "小児科",
      "cardiology": "循環器内科",
      "neurology": "神経内科",
      "orthopedics": "整形外科",
      "emergencyMedicine": "救急科"
    },
    "scope": {
      "personal": "個人",
      "group": "グループ",
      "global": "全体"
    },
    "state": {
      "draft": "下書き",
      "published": "公開済み"
    }
  },
  "components": {
    "clinicalNoteEditor": {
      "bold": "太字",
      "italic": "斜体",
      "list": "リスト",
      "templates": "テンプレート / スマートフレーズ",
      "saved": "保存済み {{time}}",
      "notSaved": "未保存",
      "charactersLabel": "文字",
      "save": "{{noteType}}を保存",
      "placeholder": "{{noteType}}の入力を開始してください…「.」を入力するとスマートフレーズが表示されます。",
      "smartPhrases": {
        "patientName": "患者名",
        "mrn": "カルテ番号",
        "dateOfBirth": "生年月日",
        "allergies": "アレルギー",
        "vitals": "バイタルサイン",
        "medications": "投薬",
        "problemList": "問題リスト"
      }
    }
  }
}
